import { User } from "./user";

export class Employee {
    public user: User;
    public workingHours: {hours: number, minutes: number};
    public activities: number;
    public locations: string[] = [];
    public rating: number;
}